module.exports = __webpack_public_path__ + "img/staff.7c963154.jpg";